//import objurl from '@/common/interface/url.js'
import objaxios from 'axios'
import objstorage from '@/common/localstorage/storage.js'
// 拦截响应response，进行错误处理
objaxios.interceptors.response.use(function (response) {
  // 成功处理
  return response;
}, function (error) {
  console.log("error")
  console.log(error)
  console.log(error.response)

      // 失败处理
  if (error.response == "" || error.response == undefined) {
    error.code = "未知错误"
    error.message = "请检查网络后联系开发商"
  }
  else {
    error.code = error.response.status
    switch (error.response.status) {
      case 400: error.message = '错误请求'
        break;
      case 401: error.message = '未授权，请重新登录'
        break;
      case 403: error.message = '拒绝访问'
        break;
      case 404: error.message = '请求错误,未找到该资源'
        break;
      case 405: error.message = '请求方法未允许'
        break;
      case 408: error.message = '请求超时'
        break;
      case 500: error.message = '服务器端出错'
        break;
      case 501: error.message = '网络未实现'
        break;
      case 502: error.message = '网络错误'
        break;
      case 503: error.message = '服务不可用'
        break;
      case 504: error.message = '网络超时'
        break;
      case 505: error.message = 'http版本不支持该请求'
        break;
      default: error.message = `连接错误${error.response.status}`
    }
  }
  return Promise.reject(error);
});

async function request(options) {
  // 这里主要是post方法的封装，get方法同理
  options.method = 'post'
  if (options.config === 'formData') {
    options.headers = { 'Content-Type': 'multipart/form-data' }
  } else {
    options.headers = { 'Content-Type': 'application/json;charset=UTF-8' }
    options.data = JSON.stringify(options.data)
  }
  //console.log(options)
  return new Promise((resolve, reject) => {
    var _this = this
   
        //console.log(response)
        // if (response.data.object == true) {
        //   objstorage.set("token", response.data.token) //保存token到本地

          objaxios(options).then(res => {
            //console.log(res);
            objstorage.set("token", res.data.token) //保存token到本地
            resolve(res.data)
            if(res.data.token==null){
              _this
              .$createDialog({
                type: "alert",
                content: "登录超时",
                icon: "cubeic-alert"
              })
              .show();
              _this.$router.push("/PageLogin")

            }else if(res.data.success==false){
              _this
              .$createDialog({
                type: "alert",
                content: "服务出错，请联系管理员",
                icon: "cubeic-alert"
              })
              .show();
              _this.$router.push("/PageLogin")
            }
            // //  这里主要根据后来返回的数据作判断，请根据实际情况
            //   if(res.data.status === 0) {
            //     resolve(res.data)
            //   } else {
            //     _this.$message.error(`status: ${res.data.status}, message: ${ res.data.message }`)
            //     reject(res.data)
            //   }
          })
          .catch(function (error) {
            //_this.$message.error(`${error.code} : ${ error.message }`)
            const toast = _this.$createToast({
              time: 1000,
              txt: `${error.code} : ${error.message}`
            })
            toast.show()
          });
        // }
        // else {
        //   objstorage.remove("token")
        //   objstorage.remove("loginId")
        //   setTimeout(() => {
        //     toast.hide()
        //     _this.$router.push('/PageLogin')
        //   }, 2000)
        // }
      })
      .catch(function (error) {
        //_this.$message.error(`${error.code} : ${ error.message }`)
        const toast = _this.$createToast({
          time: 1000,
          txt: `${error.code} : ${error.message}`
        })
        toast.show()
      });
}

export default { request }



// WEBPACK FOOTER //
// ./src/common/utils/request.js